export default __webpack_public_path__ + "static/media/map.182ef499.png";